module.exports = __webpack_public_path__ + "static/img/sssz@2x.6eae219b.png";